<template lang="pug">
.check-container(v-if="show")
  .shadow(@click="closeModal")
  .check-block(@click="closeModal")
    .check-top
      img.check-sign(src="https://m.hellobike.com/resource/gallery/61/kCyeyPnmkc.png?x-oss-process=image/quality,q_80")
      .check-line 30天内仅可退1次
    .cbeck-bottom 您在{{ getTime() }}已成功申请一次退款，{{ nextRefundDays }}天后方可再次申请～
    .check-btn(@click="closeModal") 我知道了
  </template>
<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import dayjs from 'dayjs';

export default {
  components: {
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    refundTime: {
      type: Number,
      default: 0,
    },
    nextRefundDays: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
    };
  },
  destroyed() {
  },
  created() {
  },
  methods: {
    closeModal() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_refunded',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.$emit('update:show', false);
    },
    getTime() {
      if (this.refundTime) {
        return dayjs(this.refundTime).format('YYYY.MM.DD');
      }
      return '';
    },
  },
};
</script>
<style lang="less" scoped>
.check-container {
  position: fixed;
  bottom: 0;
  z-index: 222;
  width: 100%;

  .shadow {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #000;
    opacity: 0.7;
    z-index: 100;
  }

  .check-block {
    background: #fff;
    border-radius: 0.2rem 0.2rem 0 0;
    position: relative;
    z-index: 223;
    height: 2.45rem;

    .check-top {
      display: flex;
      justify-content: center;
      padding-top: 0.3rem;

      img.check-sign {
        width: 0.24rem;
        height: 0.24rem;
        margin-right: 0.04rem;
        margin-top: 0.02rem;
      }

      .check-line {
        font-family: PingFangSC, PingFang SC, sans-serif;
        font-weight: 500;
        font-size: 0.2rem;
        color: #242729;
        line-height: 0.28rem;
      }
    }

    .cbeck-bottom {
      padding: 0 0.2rem;
      font-family: PingFangSC, PingFang SC, sans-serif;
      font-weight: 400;
      font-size: 0.14rem;
      color: #5a6066;
      line-height: 20px;
      margin: 0.14rem auto 0 auto;
      text-align: left;
    }

    .check-btn {
      margin: 0.5rem auto;
      width: 3.35rem;
      height: 0.48rem;
      background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
      border-radius: 0.08rem;
      text-align: center;
      line-height: 0.48rem;
      color: #fff;
      font-size: 0.18rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    }
  }
}
</style>
